import React, { useState, useEffect, useContext } from "react";
import classes from "../TrucksAvailable.module.css";
import axios from "../../../Axios";
import { Urls } from "../../../Urls";
// import {Activity, currentRequestTimeStamp} from '../../../Constants'
import { currentRequestTimeStamp } from "../../../Constants";
import Loader from "../../Loader";
import { toast } from "react-toastify";
import classes1 from "./enquiry.module.css";
import transport_alt from "../../../Content/images/transporter_logo.png";
import mixpanel from "mixpanel-browser";
import { useMixPanelForTracking } from "../../../utils/TrackMixPanel";
import { UserApiContext } from "../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../MyCompanyProfileContext";
import NewProfileModal from "../../Shared/NewTransporterProfileModal/NewProfileModal";
import ClarificationThread from "./Approval/ClarificationThread";
import panelStyles from "./Approval/ClarificationsPanel.module.css";
import { useEnquiryClarificationUnread } from "./Approval/useEnquiryClarificationUnread";

const ViewEnquiry = ({
  item,
  truck_enquiry_id,
  type = "",
  clarifyTransporters = [],
  currentUserLevel,
  currentUserName,
  clarificationStatus,
}) => {
  const [activeSection, setActiveSection] = useState(
    clarificationStatus === "clarification_needed" ? "clarifications" : "chat"
  );
  const [selectedClarificationTarget, setSelectedClarificationTarget] = useState(null);
  const [message, setmessage] = useState("");
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [messagelist, setMessagelist] = useState([]);
  const [show, setShow] = useState(false);
  const [selecttransporter, setSelecttransporter] = useState("");
  const [selecttransportername, setselecttransportername] = useState("");
  const [newtransporter_list, setnewtransporter_list] = useState([]);
  const [activeTransporter, setactiveTransporter] = useState({ id: "", name: "" });
  const [openProfileModal, setOpenProfileModal] = useState(false);

  // Only fetch the per-transporter unread breakdown when the enquiry already
  // shows unread activity from the grid data, so ViewEnquiry (which mounts
  // once per row regardless of whether its modal is open) doesn't turn this
  // into a get_clarification call for every row on page load.
  const hasUnreadActivity =
    (item?.no_of_msgs_received || 0) > 0 || clarificationStatus === "clarification_needed";

  const {
    unreadByTransporter: clarificationUnreadByTransporter,
    totalUnread: clarificationTotalUnread,
    refresh: refreshClarificationUnread,
  } = useEnquiryClarificationUnread({
    enquiryId: truck_enquiry_id,
    currentUserEmail: userDetails?.email,
  });

  useEffect(() => {
    if (hasUnreadActivity) refreshClarificationUnread();
  }, [hasUnreadActivity, refreshClarificationUnread]);

  useEffect(() => {
    if (hasUnreadActivity) {
      const timeout = setTimeout(refreshClarificationUnread, 1500);
      return () => clearTimeout(timeout);
    }
  }, [hasUnreadActivity, selectedClarificationTarget, refreshClarificationUnread]);

  const handleOpenProfile = (e, transporter) => {
    e.stopPropagation();
    setactiveTransporter({
      id: transporter.transporter_id,
      name: transporter.transporter_name,
    });
    setOpenProfileModal(true);
  };

  const handleCloseModal = () => {
    setOpenProfileModal(false);
    setactiveTransporter({ id: "", name: "" });
  };
  const { TrackMixPanel } = useMixPanelForTracking(
    userDetails,
    companySettingData,
  );

  useEffect(() => {
    // Initializes chat and fetches transporter data based on truck enquiry ID

    setShow(true);

    // Fetches transporter data for the specific truck enquiry
    const tList = item?.benchmark_transporter_list || item?.transporter_list || [];
    if (tList.length > 0) {
      setnewtransporter_list(tList);
      setShow(false);
    } else if (truck_enquiry_id) {
      axios
        .get(
          `${Urls.spot}?field=get_transporters&truck_enquiry_id=${truck_enquiry_id}`,
        )
        .then((res) => {
          const raw = Array.isArray(res.data)
            ? res.data
            : res.data?.benchmark_transporter_list ||
              res.data?.transporter_list ||
              res.data?.transporters ||
              res.data?.data ||
              [];
          setnewtransporter_list(raw);
        })
        .catch((err) => {
          console.error("Failed to fetch transporters for chat:", err);
        })
        .finally(() => setShow(false));
    } else {
      setShow(false);
    }

    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - chat",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}`,
      Definition: `user viewed chat modal`,
    });
  }, [truck_enquiry_id]);

  useEffect(() => {
    if (newtransporter_list.length > 0) {
      gettrucksavailablechat();
    }
  }, [newtransporter_list]);

  /**
   * Fetches available truck chat data and updates the message list.
   */
  const gettrucksavailablechat = () => {
    setShow(true);

    axios
      .get(`${Urls.enquiryChat}&truck_enquiry_id=${truck_enquiry_id}`)
      .then((res) => {
        setShow(false);
        var tl = [];

        // Process chat messages and update the message list
        if (res.data && res.data.length > 0) {
          res.data.map((mssg) => {
            if (mssg.truck_enquiry_id === truck_enquiry_id) {
              var updatedmessageList = mssg.message_list.map((ml) => {
                newtransporter_list.map((transporter) => {
                  if (transporter.transporter_id === ml.transporter_id) {
                    ml.logo = transporter.logo;
                    if (!ml.transporter_name) {
                      ml.transporter_name = transporter.transporter_name;
                    }
                  }
                });
                return ml;
              });
              // Merge chat data with full transporter list so all transporters appear in sidebar
              const chatMap = {};
              updatedmessageList.forEach((ml) => {
                chatMap[ml.transporter_id] = ml;
              });
              const mergedList = newtransporter_list.map((transporter) => {
                if (chatMap[transporter.transporter_id]) {
                  return chatMap[transporter.transporter_id];
                }
                return {
                  transporter_id: transporter.transporter_id,
                  transporter_name: transporter.transporter_name,
                  logo: transporter.logo,
                  read_status: false,
                  message_values: [],
                };
              });
              setMessagelist(mergedList);
              mergedList.map((ml) => {
                tl.push(ml.transporter_id);
              });
              setSelecttransporter(updatedmessageList[0].transporter_id);
              setselecttransportername(updatedmessageList[0].transporter_name);

              // Update the read status of the first message if needed
              if (updatedmessageList[0].read_status === false) {
                axios
                  .post(
                    `${Urls.enquiryChat}&transporter_id=${updatedmessageList[0].transporter_id}&truck_enquiry_id=${truck_enquiry_id}&update_type=transporter`,
                    {
                      transporter_id: updatedmessageList[0].transporter_id,
                      read_status: true,
                      transporter_name: updatedmessageList[0].transporter_name,
                    },
                  )
                  .then((res) => {})
                  .catch((e) => {
                    console.log(e);
                    setShow(false);
                  });
              }
            }
          });
        } else {
          if (messagelist.length <= 0) {
            var message_list = [];
            newtransporter_list.map((transporter) => {
              var mssg = {
                transporter_id: transporter.transporter_id,
                read_status: false,
                transporter_name: transporter.transporter_name,
                logo: transporter.logo,
                message_values: [],
              };
              message_list.push(mssg);
            });
            var payload = {
              truck_enquiry_id: truck_enquiry_id,
              email: userDetails?.email,
              message_list: message_list,
            };
            axios
              .post(
                `${Urls.enquiryChat}&transporter_id=${message_list[0].transporter_id}&truck_enquiry_id=${truck_enquiry_id}&update_type=transporter`,
                payload,
              )
              .then((res) => {})
              .catch((e) => {
                console.log(e);
                toast.info("Request Failed");
              });
            setMessagelist(message_list);
            setSelecttransporter(newtransporter_list[0].transporter_id);
            setselecttransportername(newtransporter_list[0].transporter_name);
          }
        }
      })
      .catch((e) => {
        setShow(false);
        console.log(e);
      });
  };

  /**
   * Converts date input to a formatted string.
   *
   * @param {Date|string} dateinput - The date to convert.
   * @returns {string} Formatted date string.
   */
  const date_conversion_enquiry = (dateinput) => {
    var date_considered = new Date(dateinput);
    var dd = date_considered.getDate();
    var mm = date_considered.getMonth() + 1;
    var yyyy = date_considered.getFullYear();
    var hours = date_considered.getHours();
    var minutes = date_considered.getMinutes();

    var month_name = [
      "",
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    var name_month = month_name[mm];
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    if (hours < 10) hours = "0" + hours;
    if (minutes < 10) minutes = "0" + minutes;

    date_considered = `${name_month} ${dd}, ${yyyy} ${hours}:${minutes}`;
    return date_considered;
  };

  // Helper function to detect SQL injection patterns
  const isSQLInjection = (input) => {
    const sqlPattern =
      /\b(SELECT\s+\*|INSERT\s+INTO|DELETE\s+FROM|UPDATE\s+\w+|DROP\s+TABLE|ALTER\s+TABLE|TRUNCATE\s+TABLE|EXEC\s+\w+|UNION\s+SELECT)\b|(--|;|'|"|\/\*|\*\/)/gi;
    return sqlPattern.test(input);
  };

  /**
   * Sends a message to the selected transporter(s).
   */
  const sendMessage = () => {
    // Validate the message for SQL injection
    if (isSQLInjection(message)) {
      alert("Your message contains potentially harmful content. Please check.");
      return; // Stop execution if SQL injection is detected
    }
    var mssg = messagelist.slice();
    TrackMixPanel({
      ModuleName: "lorri spot",
      ScreenName: "my enquiries - chat",
      Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}, message: ${message}`,
      Definition: `user sent a chat for an enquiry`,
    });
    if (selecttransporter === "all") {
      TrackMixPanel({
        ModuleName: "lorri spot",
        ScreenName: "my enquiries - chat",
        Data: `lane: ${item && item.lane_details?.origin && item.lane_details?.origin.location_name ? item.lane_details?.origin.location_name : ""} to ${item && item.lane_details?.destination && item.lane_details?.destination.location_name ? item.lane_details?.destination.location_name : ""}, truck type : ${item?.lane_details?.truck_types?.[0]?.label}, message: ${message}`,
        Definition: `user sent broadcast chat for an enquiry`,
      });
      mssg.map((m) => {
        var mlist = m.message_values;
        mlist.push({
          datetime: currentRequestTimeStamp(),
          message: message,
          unread_status: false,
          user_type: "company_user",
        });
      });

      var msglist = mssg.map((m) => {
        let tName = m.transporter_name;
        if (!tName) {
          const t = newtransporter_list.find(tr => tr.transporter_id === m.transporter_id);
          if (t) tName = t.transporter_name;
        }
        return {
          transporter_id: m.transporter_id,
          read_status: false,
          transporter_name: tName,
          message_values: [
            {
              datetime: currentRequestTimeStamp(),
              message: message,
              unread_status: false,
              user_type: "company_user",
            },
          ],
        };
      });

      var payload = { message_list: msglist };
      setShow(true);
      axios
        .post(
          `${Urls.enquiryChat}&truck_enquiry_id=${truck_enquiry_id}&send_multiple=true`,
          payload,
        )
        .then((res) => {
          setShow(false);
          document.getElementById("message").value = "";
          setmessage("");
        })
        .catch((e) => {
          console.log(e);
          setShow(false);
        });
    } else {
      mssg = mssg.map((m) => {
        if (m.transporter_id === selecttransporter) {
          var mlist = m.message_values;
          mlist.push({
            datetime: currentRequestTimeStamp(),
            message: message,
            unread_status: false,
            user_type: "company_user",
          });
        }
        return m;
      });
      setMessagelist(mssg);

      let tName = selecttransportername;
      if (!tName) {
        const t = newtransporter_list.find(tr => tr.transporter_id === selecttransporter);
        if (t) tName = t.transporter_name;
      }

      var payload = {
        transporter_id: selecttransporter,
        read_status: false,
        transporter_name: tName,
        message_values: [
          {
            datetime: currentRequestTimeStamp(),
            message: message,
            unread_status: false,
            user_type: "company_user",
          },
        ],
      };
      setShow(true);
      axios
        .post(
          `${Urls.enquiryChat}&transporter_id=${selecttransporter}&truck_enquiry_id=${truck_enquiry_id}`,
          payload,
        )
        .then((res) => {
          setShow(false);
          document.getElementById("message").value = "";
          setmessage("");
        })
        .catch((e) => {
          console.log(e);
          setShow(false);
        });
    }

    setmessage("");
  };

  /**
   * Handles changes in transporter selection.
   *
   * @param {Object|string} ml - Selected transporter or 'all'.
   */
  const changeHandler = (ml) => {
    if (ml !== "all") {
      setSelecttransporter(ml.transporter_id);
      setselecttransportername(ml.transporter_name);

      // Update read status for selected transporter if needed
      if (ml.read_status === false) {
        axios
          .post(
            `${Urls.enquiryChat}&transporter_id=${ml.transporter_id}&truck_enquiry_id=${truck_enquiry_id}&update_type=transporter`,
            {
              transporter_id: ml.transporter_id,
              read_status: true,
              transporter_name: ml.transporter_name,
            },
          )
          .then((res) => {
            ml.transporter_unread_count = 0;
          })
          .catch((e) => {
            console.log(e);
            setShow(false);
          });
      }
    } else {
      setSelecttransporter("all");
      setselecttransportername("all");
    }
  };

  /**
   * Returns the image source for a transporter logo or fallback.
   *
   * @param {string} logo - The logo file name.
   * @returns {string} Image source URL.
   */
  const getImageSrc = (logo) => {
    if (logo) return `${Urls.showlogo}/${logo}`;
    return transport_alt;
  };

  /**
   * Handles key down events in the message input field.
   *
   * @param {KeyboardEvent} e - The key down event.
   */
  const HandleKeyDown = (e) => {
    const messageInput = document.getElementById("message");

    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      const cursorPosition = messageInput.selectionStart;
      const newValue =
        messageInput.value.substring(0, cursorPosition) +
        "\n" +
        messageInput.value.substring(cursorPosition);
      messageInput.value = newValue;
      messageInput.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
    } else if (e.key === "Enter" && !e.altKey) {
      e.preventDefault();
      const trimmedMessage = messageInput.value.trim();
      if (trimmedMessage) {
        // Append the trimmed message to the existing message state with a newline
        setmessage((prevMessage) => prevMessage + trimmedMessage + "\n");
        messageInput.value = ""; // Clear the message input after sending
        sendMessage(); // Call your sendMessage function
      }
    }
  };

  /**
   * Handles image fallback if the logo fails to load.
   *
   * @param {Event} e - The image error event.
   */
  const imageFallBack = (e) => {
    e.target.src = transport_alt;
  };

  const effectiveClarifyTransporters =
    clarifyTransporters.length > 0 ? clarifyTransporters : newtransporter_list;

  useEffect(() => {
    if (selectedClarificationTarget === null && effectiveClarifyTransporters.length > 0) {
      setSelectedClarificationTarget(effectiveClarifyTransporters[0].transporter_id);
    }
  }, [selectedClarificationTarget, effectiveClarifyTransporters]);

  const selectedClarificationTransporter = effectiveClarifyTransporters.find(
    (t) => t.transporter_id === selectedClarificationTarget
  ) || null;

  return (
    <>
      <Loader show={show} />
      <div style={{ display: "flex", gap: "20px", marginBottom: "12px", borderBottom: "2px solid #e4e8f0" }}>
        <button
          type="button"
          onClick={() => setActiveSection("chat")}
          style={{
            background: "none",
            border: "none",
            padding: "8px 2px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            color: activeSection === "chat" ? "#393185" : "#888",
            borderBottom: activeSection === "chat" ? "2px solid #393185" : "2px solid transparent",
            marginBottom: "-2px",
          }}
        >
          Chat
        </button>
        <button
          type="button"
          onClick={() => setActiveSection("clarifications")}
          style={{
            background: "none",
            border: "none",
            padding: "8px 2px",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
            color: activeSection === "clarifications" ? "#393185" : "#888",
            borderBottom: activeSection === "clarifications" ? "2px solid #393185" : "2px solid transparent",
            marginBottom: "-2px",
          }}
        >
          Clarifications
          {clarificationTotalUnread > 0 && (
            <span className={panelStyles.tabBadge}>{clarificationTotalUnread}</span>
          )}
        </button>
      </div>
      {activeSection === "clarifications" ? (
        effectiveClarifyTransporters.length >= 1 ? (
          <div className={panelStyles.wrapper}>
            <div className={panelStyles.sidebar}>
              {effectiveClarifyTransporters.map((t) => {
                const unread = clarificationUnreadByTransporter[t.transporter_id] || 0;
                return (
                  <div
                    key={t.transporter_id}
                    onClick={() => setSelectedClarificationTarget(t.transporter_id)}
                    className={`${panelStyles.sidebarRow} ${
                      selectedClarificationTarget === t.transporter_id ? panelStyles.sidebarRowActive : ""
                    }`}
                    title={t.transporter_name}
                  >
                    <span className={panelStyles.sidebarRowLabel}>
                      {t.transporter_name && t.transporter_name.length < 28
                        ? t.transporter_name
                        : `${(t.transporter_name || "").substring(0, 28)}...`}
                    </span>
                    {unread > 0 && <span className={panelStyles.unreadBadge}>{unread}</span>}
                  </div>
                );
              })}
            </div>
            <div className={panelStyles.main}>
              {selectedClarificationTransporter && (
                <ClarificationThread
                  key={selectedClarificationTransporter.transporter_id}
                  enquiryId={truck_enquiry_id}
                  forTransporterId={selectedClarificationTransporter.transporter_id}
                  currentUserLevel={currentUserLevel}
                  currentUserEmail={userDetails?.email}
                  currentUserName={currentUserName}
                />
              )}
            </div>
          </div>
        ) : (
          <div className={panelStyles.emptyState}>No transporters found for this enquiry.</div>
        )
      ) : (
      <div className="row">
        {messagelist && messagelist.length > 0 ? (
          <>
            <div className={`col-md-4 ${classes["tr-list"]}`}>
              <div
                style={{
                  overflowY: "auto",
                  overflowX: "hidden",
                  height: "100%",
                }}
              >
                <div>
                  <div
                    onClick={(e) => changeHandler("all")}
                    style={{
                      height: "7vh",
                      color: "#393186",
                      fontWeight: "600",
                      padding: "5%",
                    }}
                    className={
                      selecttransporter === "all"
                        ? classes1["tr-namess"]
                        : classes1["tr-names"]
                    }
                  >
                    <span>Broadcast to All</span>
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      height: "7vh",
                      color: "#393186",
                      fontWeight: "600",
                      padding: "5%",
                    }}
                    className={classes1["only-names"]}
                  >
                    <span>Send Message to Transporters</span>
                  </div>
                </div>
                {messagelist.map((ml, index) => {
                  return (
                    <div
                      onClick={(e) => changeHandler(ml)}
                      key={`transporter${index}`}
                      className={
                        ml.transporter_id === selecttransporter
                          ? ml.transporter_unread_count !== 0 &&
                            ml.transporter_unread_count !== undefined
                            ? classes1["bg-new"]
                            : classes1["tr-namess"]
                          : ml.transporter_unread_count !== 0 &&
                              ml.transporter_unread_count !== undefined
                            ? classes1["bg-new"]
                            : classes1["tr-names"]
                      }
                    >
                      {ml.transporter_unread_count &&
                      ml.transporter_unread_count !== 0 ? (
                        <div className={`row`}>
                          {/** */}
                          <div className="col-md-3">
                            <div className={`${classes["avatar-circle"]}`}>
                              <img
                                className={`${classes["s-a"]}`}
                                src={getImageSrc(ml.logo)}
                                onError={(e) => imageFallBack(e)}
                                alt="avatar"
                              />
                            </div>
                          </div>
                          <div className={`col-md-9 ${classes1["myborder"]}`}>
                            {/** color: '#54af3a',  */}
                            <span
                              style={{ fontSize: "13px", cursor: "pointer", textDecoration: "underline" }}
                              onClick={(e) => handleOpenProfile(e, ml)}
                              title="View Transporter Profile"
                            >
                              {ml.transporter_name &&
                              ml.transporter_name.length < 25
                                ? ml.transporter_name.toUpperCase()
                                : `${ml.transporter_name
                                    .toUpperCase()
                                    .substring(0, 25)}...`}
                            </span>
                            <span className={`${classes1["chat_number"]}`}>
                              {ml.transporter_unread_count}
                            </span>
                            <div
                              style={{
                                height: "17px",
                                fontSize: "11px",
                                overflow: "hidden",
                              }}
                            >
                              {ml.message_values && ml.message_values.length > 0
                                ? ml.message_values[
                                    ml.message_values.length - 1
                                  ].message.length < 15
                                  ? ml.message_values[
                                      ml.message_values.length - 1
                                    ].message
                                  : `${ml.message_values[
                                      ml.message_values.length - 1
                                    ].message.substring(0, 15)}...`
                                : null}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-md-3">
                            <div className={`${classes["avatar-circle"]}`}>
                              <img
                                className={`${classes["s-a"]}`}
                                src={getImageSrc(ml.logo)}
                                onError={(e) => imageFallBack(e)}
                                alt="avatar"
                              />
                            </div>
                          </div>
                          <div className={`col-md-9 ${classes1["myborder"]}`}>
                            <span
                              style={{ fontSize: "13px", cursor: "pointer", textDecoration: "underline" }}
                              onClick={(e) => handleOpenProfile(e, ml)}
                              title="View Transporter Profile"
                            >
                              {ml.transporter_name &&
                              ml.transporter_name.length < 25
                                ? ml.transporter_name.toUpperCase()
                                : `${ml.transporter_name
                                    .toUpperCase()
                                    .substring(0, 25)}...`}
                            </span>
                            <div
                              style={{
                                height: "17px",
                                fontSize: "11px",
                                overflow: "hidden",
                              }}
                            >
                              {ml.message_values && ml.message_values.length > 0
                                ? ml.message_values[
                                    ml.message_values.length - 1
                                  ].message.length < 15
                                  ? ml.message_values[
                                      ml.message_values.length - 1
                                    ].message
                                  : `${ml.message_values[
                                      ml.message_values.length - 1
                                    ].message.substring(0, 15)}...`
                                : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={`col-md-7 ${classes["tr-chat"]}`}>
              {messagelist.map((ml, index) => {
                if (ml.transporter_id === selecttransporter) {
                  var msgvalues = ml.message_values.map((msg, index) => {
                    return (
                      <div
                        key={index}
                        className={
                          msg.user_type === "transporter"
                            ? classes1["s-chat-list-left"]
                            : classes1["s-chat-list"]
                        }
                      >
                        {/* <span style={{ margin: '4%'}} >{msg.message}\n <br /> </span> */}
                        {msg.message.split("\n").map((messageLine, index) => (
                          <span
                            key={index}
                            style={{ margin: "4%", wordBreak: "break-word" }}
                          >
                            {messageLine}
                            <br />
                          </span>
                        ))}
                        <span
                          style={{
                            float: "right",
                            fontStyle: "italic",
                            marginRight: "1%",
                            fontSize: "11px",
                          }}
                        >
                          {date_conversion_enquiry(msg.datetime)}
                        </span>
                      </div>
                    );
                  });
                  return (
                    <div key={`messagelist${index}`}>
                      <span
                        style={{ cursor: "pointer", color: "#393186", fontWeight: "bold", textDecoration: "underline" }}
                        onClick={(e) => handleOpenProfile(e, ml)}
                        title="View Transporter Profile"
                      >
                        {ml.transporter_name.toUpperCase()}
                      </span>
                      <div className={classes["s-chat"]}>
                        {msgvalues && msgvalues.length > 0
                          ? msgvalues
                          : "Please Add Messages"}
                      </div>
                    </div>
                  );
                }
              })}
              <div className={classes["s-div-inputs"]}>
                {/* <span className={classes['response-characters-allowed']}>1500 characters allowed</span> */}
                <div
                  className="form-group"
                  style={{ display: "flex", marginTop: "1%" }}
                >
                  <textarea
                    style={{
                      minHeight: "105px",
                      height: "auto",
                      minWidth: "90%",
                    }}
                    rows="2"
                    type="text"
                    value={message}
                    className={`${classes["s-message"]}`}
                    placeholder="Type a message"
                    id="message"
                    onChange={(event) => setmessage(event.target.value)}
                    onKeyDown={(e) => HandleKeyDown(e)}
                  />
                  <button
                    disabled={message !== "" && message !== null ? false : true}
                    onClick={(e) => sendMessage()}
                    className={`btn btn-sm btn-primary ${classes["s-sent"]}`}
                  >
                    <i className="fa fa-paper-plane" />
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ justifyContent: "center", width: "100%" }}>
            <center>No Enquiry received</center>
          </div>
        )}
      </div>
      )}
      {openProfileModal && activeTransporter?.id !== "" && (
        <NewProfileModal
          isOpen={openProfileModal}
          onClose={handleCloseModal}
          transporter_id={activeTransporter.id}
          transporter_name={activeTransporter.name}
          screenName={"LoRRI Adhoc"}
          moduleName={"My Enquiries"}
          transporter_list={newtransporter_list}
        />
      )}
    </>
  );
};

export default ViewEnquiry;
